import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, REQUEST} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SSRLangService {
  
  private platformId = inject(PLATFORM_ID);
  private cookieService = inject(CookieService);
  private request = inject(REQUEST);
  private lang = 'ar';

  setLangViaCookie(lang :string){
    if (isPlatformBrowser(this.platformId)){
      this.cookieService.set('lang',lang);
    }
  }

  getLang(){
    if (isPlatformServer(this.platformId)){
      const langCookie = this.request!.headers.get('cookie');
      if (langCookie){
        return this.getLangCookie(langCookie);
      }
    }
    else{
      return this.cookieService.get('lang');
    }
    return null;
  }

  private getLangCookie(cookieString: string){

    const results = cookieString.split(';');
    for (const result of results){
      let [key,value] = result.split('=');
      key = key.trim();
      value = value.trim();
      if (key==='lang'){
        return value;
      }
    }
    return null;
  }
}
